import { fileTypeToken, formatBytes } from '../asset-tile/asset-format'

/**
 * How many qualifiers a tile shows. Two fits the narrowest tile and is enough to separate
 * the repeats a real list holds; a full dump would not be readable at this size and would
 * bury the one value that actually differs.
 */
export const MAX_QUALIFIERS = 2

/**
 * What a tile says about itself when no thumbnail resolved: the role it plays, then
 * the values that separate it from its siblings in that role - `Market logo · es-ES`.
 *
 * The role is always present, so the label never degrades below what the group heading
 * already says. At most {@link MAX_QUALIFIERS} qualifiers are taken, in the order the host
 * supplied them.
 */
export function tilePlaceholderLabel(roleLabel: string, qualifiers: string[]): string {
	const shown = qualifiers.map((value) => value.trim()).filter((value) => value !== '')
	return [roleLabel, ...shown.slice(0, MAX_QUALIFIERS)].join(' · ')
}

/**
 * The tile's binary footing - `SVG · 12 KB`, or just `SVG` when the size is unknown.
 *
 * Says what the qualifiers cannot: which of two same-role, same-locale assets is the vector
 * and which the raster, and which is the print-weight one. The size is omitted rather than
 * shown as a dash, because a dash in a footer reads as a missing value the reader should
 * worry about.
 */
export function tileFormatLabel(contentType: string, fileName: string, fileSize?: number | null): string {
	const token = fileTypeToken(contentType, fileName)
	const size = formatBytes(fileSize ?? null)
	return size === '-' ? token : `${token} · ${size}`
}
